import React from "react";
import { Box } from "@mui/material";

// Radial glow + dotted-grid backdrop used behind every dark public-page hero.
// Parent must be position: relative; overflow: hidden.
const DarkHeroBackdrop = () => (
  <>
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        background:
          "radial-gradient(ellipse 60% 70% at 78% 42%, rgba(45,27,105,.8) 0%, transparent 60%), radial-gradient(ellipse 38% 50% at 5% 78%, rgba(124,58,237,.14) 0%, transparent 55%)",
      }}
    />
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        backgroundImage: "radial-gradient(rgba(124,58,237,.14) 1px, transparent 1px)",
        backgroundSize: "44px 44px",
        maskImage: "radial-gradient(ellipse 80% 80% at 50% 50%, black 0%, transparent 100%)",
        WebkitMaskImage: "radial-gradient(ellipse 80% 80% at 50% 50%, black 0%, transparent 100%)",
      }}
    />
  </>
);

export default DarkHeroBackdrop;
